module.exports = __webpack_public_path__ + "media/images/user/favicons/apple-touch-icon-22c3a62fcd7a3cd87e0fa1e68e610049.png";